const FILENAME_MAX_LENGTH = 255;

/** Strips characters that are illegal in Windows/macOS file names. */
export const escapeFilename = (filename: string) =>
    filename.replace(/[<>:"/\\|?*\x00-\x1F]/g, '_').trim();

export const truncateFilename = (filename: string, length: number = FILENAME_MAX_LENGTH) =>
    filename.length > length ? filename.substring(0, length) : filename;

/**
 * Hands a blob to the browser as a download. The object URL is revoked right
 * after the click so the blob does not stay pinned in memory for the session.
 */
export const downloadBlobAsFile = (blob: Blob, filename: string) => {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = url;
    link.download = truncateFilename(escapeFilename(filename));
    link.click();

    window.URL.revokeObjectURL(url);
};
